import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import {API_URL} from '../../constants';
import {updateValueInJson, getRoles, GetMenuHeader, GetMenuHeaderByGroup, validateUrl} from '../../functions';
import axios from 'axios';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import Select from 'react-select'
import SelectByValue from '../components/SelectByValue';
import CKEditor from 'ckeditor4-react';
import { cacheConfig, getFrontPageUrl } from '../../utils/functions';


let config = {    
	height : '230px',
    width :'65%',
	addCss: '.divImagenConBajada img{width: 100% !important;}',
	toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		'/',
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'Outdent', 'blocks', 'align', 'bidi', 'paragraph','iframe' ,'Anchor'] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
	removeButtons : 'Save,NewPage,Preview,Print,Templates,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Subscript,Superscript,Strike,CopyFormatting,JustifyRight,BidiLtr,BidiRtl,Language,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,FontSize,Font,Maximize,ShowBlocks,About,Intent',
	stylesSet : [
		{ name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
		{ name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
		{ name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
		{ name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
	],
	div_wrapTable : true,
	extraAllowedContent: 'section class iframe style video embed',
	allowedContent : true,
	image: {toolbar: [ 'imageTextAlternative' ]},
	extraPlugins : 'embed, iframe',
	embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
	skin : 'kama'
}

export default class Configuradores extends Component {

    constructor(props) {

        super(props);

        this.state = {
            resource: {
                eRedesSociales:[],
                generales:[],
                footer:[],
                pformEncuestas:[],
                smtp:[],
                mailingHTML:[],
                limitesTiposRecurso:[],
                seoPortalTracking:[],
                fuentesGrafico:[],
                servicioEnvioCorreo: [],
                notificacionPorBloque: [],
                servicioEnvioNotificacionPush: [],
                servicioEmblue: [],
                notificacionTiempoEspera: [],
                suscripcionWeb: [],
                fichaPartida: [],
                fichaMercado: []
            },
            hasError:           false,
            hasErrorProceso:    false,
            added:              false,
            security:           cookie.load('user'),
            roles:              [],
            menuGeneral:        [],
            menus:              [],
            agrupador:          "Parámetros",
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleHTMLChange(tipo = "", indice = 0, val) {
        let resource = this.state.resource;
        resource[tipo][indice].sValor = val.editor.getData();

        this.setState({
            resource: resource
        });
    }

    handleInputChange(tipo = "", indice = 0, event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let resource = this.state.resource;
        resource[tipo][indice].sValor = value;

        this.setState({
            resource: resource
        });
    }

    handleInputChangeBySelect(tipo = "", indice = 0, value) {
        console.log('change', value);

        // const target = event.target;
        // const value = target.type === 'checkbox' ? target.checked : target.value;

        let resource = this.state.resource;
        resource[tipo][indice].sValor = value.value;

        this.setState({
            resource: resource
        });
    }

    componentDidMount(){

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        // console.log(this.props.location);

        // let newState  = this.props.location;
        let agrupador = this.state.agrupador;
        //console.log("load menu", newState);  

        validateUrl(this.props.menuGeneral, "", agrupador);     
        // var menus = GetMenuHeaderByGroup(this.props.menu, agrupador);

        // console.log("load menu", this.props.menu);  

        let menuByGroup = this.props.menu.find((item) => item.sAgrupador === agrupador).sMenu;

        this.setState({
            menuGeneral: this.props.menuGeneral,
            menus:       menuByGroup
        });  
        
        
        const url = `${API_URL}ParametroUX/Parametros`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            console.log(data);

            this.setState({ 
                resource: data.result, 
                response: data, 
                error: data.Error 
            });
        })
        .catch(error => {
            toast.error("¡Error al inicializar!");
        });

    }

    deleteCache = (slug, productoCodigo) => {
        const baseUrl   = getFrontPageUrl();
        const urldeleteCache = `${baseUrl}/cache/limpiar-parametros`;
        axios.delete(
            urldeleteCache, 
            cacheConfig
        ).then((res) => {

            console.log(res.data);
            console.log(res.data.message);

        }).catch((err) => {
            console.error(err);
        });
    }

    callFunctionButton = (event) => {

        let newState = this.state;

        const url = `${API_URL}ParametroUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'nUsuarioModificacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

		$(".ipl-progress-indicator").fadeIn();
		$(".ipl-progress-indicator-head").css({"width": "90%"});
		
        axios.put(url,JSON.stringify(formData), { 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {

			$(".ipl-progress-indicator-head").css({"width": "100%"});
			    setTimeout(function()
			{
				$(".ipl-progress-indicator").hide();
				$(".ipl-progress-indicator-head").css({"width": "0%"});
			}, 200);
			
            if (data.data.isSucess){
                let stateResponse = this.state;
                stateResponse.added = true;

                this.deleteCache();
                this.setState(stateResponse);
                setTimeout(() => {
                    this.setState({
                        added:false
                    });
                }, 5000);
            }else{
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }

			setTimeout(() => {
				$("html, body").stop().animate({scrollTop:0}, 500, 'swing');
			}, 1000);

        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({
                loading:false
            });
        });
    }

    render() {
        return (
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">        
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a>
                        <span> / Parámetros</span>

                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Panel de configuración general
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }

                <div className="divConfiguracion_Panel">

                    <div className="divTituloDesplegable_Panel">Enlaces de Redes Sociales</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.eRedesSociales.length > 0 ?
                            this.state.resource.eRedesSociales.map((param, index) => (
                                <React.Fragment key={index}>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'eRedesSociales[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("eRedesSociales", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'eRedesSociales[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("eRedesSociales", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Generales</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.generales.length > 0 ?
                            this.state.resource.generales.map((param, index) => (
                                <React.Fragment key={index}>
                                <div className="imgLogoPortal">

                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>

                                    {(param.sClave === 'SCRIPT' || param.sClave === 'DTBG') &&
                                            <div className="txtChatOnline">
                                                <textarea
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'generales[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("generales", index, event)}
                                                />
                                            </div>
                                    }

                                    {(param.sClave === 'HTML') &&
                                        <div className="isContenidoPanel">
                                            
                                                <CKEditor
                                                    data={param.sValor}
                                                    //onChange={this.onEditorChangeEdit} 
                                                    onChange={(event) => this.handleHTMLChange("generales", index, event)}
                                                    config={config}
                                                />
                                            
                                        </div>
                                    }

                                    {!(param.sClave === 'SCRIPT' || param.sClave === 'DTBG' || param.sClave === 'HTML') &&
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                    placeholder={param.sDescripcion}
                                                    id={param.sTipo}
                                                    value={param.sValor}
                                                    name={'generales[' + index + ']'}
                                                    onChange={(event) => this.handleInputChange("generales", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Parámetros del Footer</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.footer.length > 0 ?
                            this.state.resource.footer.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'footer[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("footer", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'footer[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("footer", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Preguntas de Formulario de Encuesta</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.pformEncuestas.length > 0 ?
                            this.state.resource.pformEncuestas.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'pformEncuestas[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("pformEncuestas", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'pformEncuestas[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("pformEncuestas", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Parámetros de SMTP</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.smtp.length > 0 ?
                            this.state.resource.smtp.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'smtp[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("smtp", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'smtp[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("smtp", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>


                    <div className="divTituloDesplegable_Panel">Mailing HTML</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.mailingHTML.length > 0 ?
                            this.state.resource.mailingHTML.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'mailingHTML[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("mailingHTML", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'mailingHTML[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("mailingHTML", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Parámetros de Límites y Tipos de Recurso</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.limitesTiposRecurso.length > 0 ?
                            this.state.resource.limitesTiposRecurso.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'limitesTiposRecurso[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("limitesTiposRecurso", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'limitesTiposRecurso[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("limitesTiposRecurso", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>


                    <div className="divTituloDesplegable_Panel">SEO Portal / Tracking</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.seoPortalTracking.length > 0 ?
                            this.state.resource.seoPortalTracking.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                            placeholder={param.sDescripcion}
                                            id={param.sTipo}
                                            value={param.sValor}
                                            name={'seoPortalTracking[' + index + ']'}
                                            onChange={(event) => this.handleInputChange("seoPortalTracking", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'seoPortalTracking[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("seoPortalTracking", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>
					
					<div className="divTituloDesplegable_Panel">Fuentes de Gráficos</div>
					<div className="divContenidoDesplegable_Panel">
						{
							this.state.resource.fuentesGrafico.length > 0 ?
							this.state.resource.fuentesGrafico.map((param, index) => (
								<React.Fragment>
								<div className="imgLogoPortal">
									<div className="isTituloPanel">
										{param.sDescripcion}
									</div>
									{
										param.sClave === 'SCRIPT' ?
										<div className="txtChatOnline">
											<textarea
											placeholder={param.sDescripcion}
											id={param.sTipo}
											value={param.sValor}
											name={'fuentesGrafico[' + index + ']'}
											onChange={(event) => this.handleInputChange("fuentesGrafico", index, event)}
											/>
										</div>
										:
										<div className="isContenidoPanel">
											<div className="txtFile" style={{width: '100%'}}>
												<input 
                                                    type="text"
                                                    placeholder={param.sDescripcion}
                                                    id={param.sTipo}
                                                    value={param.sValor}
                                                    name={'fuentesGrafico[' + index + ']'}
                                                    onChange={(event) => this.handleInputChange("fuentesGrafico", index, event)}
												/>
											</div>
										</div>
									}

								</div>
								<br />
								</React.Fragment>
							)) : null
						}
					</div> 

                    <div className="divTituloDesplegable_Panel">Servicio de envío de correos</div>
					<div className="divContenidoDesplegable_Panel">
                        {this.state.resource.servicioEnvioCorreo.length > 0 &&
                            <div>
                                {this.state.resource.servicioEnvioCorreo.map((param, index) => {
                                    if(param.sNomenclatura === "servicioEnvioCorreo1"){
                                        return (
                                            <div className="imgLogoPortal2">
                                                <div className="isTituloPanel">
                                                    {param.sDescripcion}
                                                </div>
                                                <div className="isContenidoPanel2">
                                                    <div style={{width: '100%'}}>
                                                        <SelectByValue 
                                                            options={[
                                                                // {label: "SMTP", value: "S"},
                                                                {label: "emBlue", value: "E"}
                                                            ]}
                                                            value={param.sValor}
                                                            name={'servicioEnvioCorreo[' + index + ']'}
                                                            onChange={(value) => this.handleInputChangeBySelect("servicioEnvioCorreo", index, value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }

                                    if(param.sNomenclatura === "servicioEnvioCorreo2"){
                                        return (
                                            <div className="imgLogoPortal2">
                                                <div className="isTituloPanel">
                                                    {param.sDescripcion}
                                                </div>
                                                <div className="isContenidoPanel2">
                                                    <div style={{width: '100%'}}>
                                                        <SelectByValue 
                                                            options={[
                                                                {label: "SI", value: "S"},
                                                                {label: "NO", value: "N"}
                                                            ]}
                                                            value={param.sValor}
                                                            name={'servicioEnvioCorreo[' + index + ']'}
                                                            onChange={(value) => this.handleInputChangeBySelect("servicioEnvioCorreo", index, value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                })}
                            </div>
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Tiempo de espera para envío de correos</div>
					<div className="divContenidoDesplegable_Panel">
                        {this.state.resource.notificacionTiempoEspera.length > 0 &&
                            <div>
                                {this.state.resource.notificacionTiempoEspera.map((param, index) => {
                                    return (
                                        <div className="imgLogoPortal2">
                                            <div className="isTituloPanel">
                                                {param.sDescripcion}
                                            </div>
                                            <div className="isContenidoPanel2">
                                                <div style={{width: '100%'}}>
                                                    <SelectByValue 
                                                        options={[
                                                            {label: "0 minutos", value: "0"},
                                                            {label: "15 minutos", value: "15"},
                                                            {label: "30 minutos", value: "30"},
                                                            {label: "45 minutos", value: "45"},
                                                            {label: "1 hora", value: "60"},
                                                            {label: "1 hora 15 minutos", value: "75"},
                                                            {label: "1 hora 30 minutos", value: "90"},
                                                            {label: "1 hora 45 minutos", value: "105"},
                                                            {label: "2 horas", value: "120"},
                                                            {label: "1 día", value: "1440"},
                                                            {label: "2 días", value: "2880"}
                                                        ]}
                                                        value={param.sValor}
                                                        name={'notificacionTiempoEspera[' + index + ']'}
                                                        onChange={(value) => this.handleInputChangeBySelect("notificacionTiempoEspera", index, value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Servicio de envío de notificaciones push</div>
					<div className="divContenidoDesplegable_Panel">
                        {this.state.resource.servicioEnvioNotificacionPush.length > 0 &&
                            <div>
                                {this.state.resource.servicioEnvioNotificacionPush.map((param, index) => {
                                    return (
                                        <div className="imgLogoPortal2">
                                            <div className="isTituloPanel">
                                                {param.sDescripcion}
                                            </div>
                                            {
                                                param.sClave === 'ENPP' ?
                                                <div className="isContenidoPanel2">
                                                    <div style={{width: '100%'}}>
                                                        <SelectByValue 
                                                            options={[
                                                                {label: 'Default ("Normal": Android, "High": iOS)', value: 'D'},
                                                                {label: 'Normal', value: 'N'},
                                                                {label: 'High', value: 'H'}
                                                            ]}
                                                            value={param.sValor}
                                                            name={'servicioEnvioNotificacionPush[' + index + ']'}
                                                            onChange={(value) => this.handleInputChangeBySelect("servicioEnvioNotificacionPush", index, value)}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className="isContenidoPanel">
                                                    <div className="txtFile" style={{width: '100%'}}>
                                                        <input 
                                                            type="text"
                                                            placeholder={param.sDescripcion}
                                                            id={param.sTipo}
                                                            value={param.sValor}
                                                            name={'servicioEnvioNotificacionPush[' + index + ']'}
                                                            onChange={(event) => this.handleInputChange("servicioEnvioNotificacionPush", index, event)}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Bloques de correos SMTP</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.notificacionPorBloque.length > 0 ?
                            this.state.resource.notificacionPorBloque.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' ?
                                            <div className="txtChatOnline"></div>
                                        :
                                            <div className="isContenidoPanel">
                                                <div className="txtFile" style={{width: '100%'}}>
                                                    <input 
                                                        type="number"
                                                        placeholder={param.sDescripcion}
                                                        id={param.sTipo}
                                                        value={param.sValor}
                                                        name={'notificacionPorBloque[' + index + ']'}
                                                        onChange={(event) => this.handleInputChange("notificacionPorBloque", index, event)}
                                                    />
                                                </div>
                                            </div>
                                    }
                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Credenciales emBlue</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.servicioEmblue.length > 0 ?
                            this.state.resource.servicioEmblue.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'SCRIPT' || param.sClave === 'PPHRB' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'servicioEmblue[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("servicioEmblue", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input 
                                                    type="text"
                                                    placeholder={param.sDescripcion}
                                                    id={param.sTipo}
                                                    value={param.sValor}
                                                    name={'servicioEmblue[' + index + ']'}
                                                    onChange={(event) => this.handleInputChange("servicioEmblue", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>

                    <div className="divTituloDesplegable_Panel">Parámetros para Suscripción del Home</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.suscripcionWeb.length > 0 ?
                            this.state.resource.suscripcionWeb.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div>
                                    {
                                        param.sClave === 'BODY' ?
                                        <div className="txtChatOnline">
                                            <textarea
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'suscripcionWeb[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("suscripcionWeb", index, event)}
                                            />
                                        </div>
                                        :
                                        <div className="isContenidoPanel">
                                            <div className="txtFile" style={{width: '100%'}}>
                                                <input 
                                                    type="text"
                                                    placeholder={param.sDescripcion}
                                                    id={param.sTipo}
                                                    value={param.sValor}
                                                    name={'suscripcionWeb[' + index + ']'}
                                                    onChange={(event) => this.handleInputChange("suscripcionWeb", index, event)}
                                                />
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>
					
                    <div className="divTituloDesplegable_Panel">Ficha de Producto</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.fichaPartida.length > 0 ?
                            this.state.resource.fichaPartida.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div> 
                                    <div className="isContenidoPanel">
                                        <div className="txtFile" style={{width: '100%'}}>
                                            <input 
                                                type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'fichaPartida[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("fichaPartida", index, event)}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>


                    <div className="divTituloDesplegable_Panel">Ficha de Mercado</div>
                    <div className="divContenidoDesplegable_Panel">
                        {
                            this.state.resource.fichaMercado.length > 0 ?
                            this.state.resource.fichaMercado.map((param, index) => (
                                <React.Fragment>
                                <div className="imgLogoPortal">
                                    <div className="isTituloPanel">
                                        {param.sDescripcion}
                                    </div> 
                                    <div className="isContenidoPanel">
                                        <div className="txtFile" style={{width: '100%'}}>
                                            <input 
                                                type="text"
                                                placeholder={param.sDescripcion}
                                                id={param.sTipo}
                                                value={param.sValor}
                                                name={'fichaMercado[' + index + ']'}
                                                onChange={(event) => this.handleInputChange("fichaMercado", index, event)}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>
                                <br />
                                </React.Fragment>
                            )) : null
                        }
                    </div>


                    <div className="divContenedorBtn_Noticias">
                        <a 
                            href="#"  
                            className="btnActivo noneEvent"  
                            onClick={(event) => this.callFunctionButton(event)}>
                            GUARDAR CAMBIOS
                        </a>
                    </div>
                </div>
            </div>

        )
    }
}
